import AutoclickBehaviorAbstract from "../AutoclickBehaviorAbstract";

class AutoclickBehaviorLastInteraction extends AutoclickBehaviorAbstract {
  onInteraction() {
    this.delayClickthrough(this.getBehaviorDelay());
  }
}

export default AutoclickBehaviorLastInteraction;



// WEBPACK FOOTER //
// ./src/js/madlib/autoclick/behaviors/AutoclickBehaviorLastInteraction.js